import { ETrackingEventType } from '@constants';
import { ICreateTrackingEvent, ITrackingEventDataMapping } from '@sdk/contracts';
import { useCallback } from 'react';

import { sdk } from '@/services';
import { useProfile } from '@/store';
import { detectDevice } from '@/utils';

const TrackingEventService = sdk.getService('TrackingEventService');

type ITrackingEventParams<T extends ETrackingEventType> = {
  eventType: T;
  eventData: ITrackingEventDataMapping[T];
};

export const useTrackingEvents = () => {
  const { profile } = useProfile();

  const trackEvent = useCallback(
    async <T extends ETrackingEventType>({ eventType, eventData }: ITrackingEventParams<T>) => {
      try {
        if (!profile) {
          throw new Error('User profile required for tracking');
        }

        if (!eventData || typeof eventData !== 'object') {
          throw new Error(`Invalid eventData for ${eventType}`);
        }

        const trackingEvent: ICreateTrackingEvent = {
          eventType,
          user: profile._id,
          academyId: profile.academy._id,
          platformUrl: window.location.href,
          userDevice: detectDevice(),
          userAgent: navigator.userAgent,
          eventData
        };

        await TrackingEventService.createTrackingEvent(trackingEvent);
      } catch (error) {
        console.error('Failed to track event:', error);
      }
    },
    [profile]
  );

  return {
    trackEvent
  };
};
